<template>
	<gmap-map
      :center="{ lat: 20.6618845, lng: -103.2784853}"
      :zoom="16"
      style="width:100%;  height: 400px;"
    >
	    <gmap-marker
	        :key="index"
	        v-for="(m, index) in markers"
	        :position="m.position"
	        @click="center=m.position"
	      ></gmap-marker>
    </gmap-map>
</template>
<script>
export default {
  name: "GoogleMap",
  data() {
    return {
      // default to Montreal to keep it simple
      // change this to whatever makes sense
      center: { lat: 20.6618845, lng: -103.2784853},
      markers: [{
      	position: { lat: 20.6618845, lng: -103.2784853},
      	title: "Industrias de Nutracéuticos"
      }],
      places: [],
      currentPlace: null
    };
  },

  mounted() {
    this.geolocate();
  },

  methods: {
    // receives a place object via the autocomplete component
    setPlace(place) {
      this.currentPlace = place;
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
      }
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    }
  }
};
</script>